export enum FeatureFlag {
  GiftCard = 'gift-card-feature',
  AllowanceEmail = 'allowance-email',
  PaymentFlow = 'payment-flow-feature',
  ResendFailedEmail = 'resend-failed-email-feature',
  MultiSelectEmployees = 'multi-select-employees'
}

export enum TestId {
  SideDrawerErrorMessage = 'side-drawer-error-message'
}

export enum ButtonState {
  Loading = 'is-loading',
  Idle = 'is-idle',
  Success = 'is-success'
}
